<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">Prompt template</h1>
        </b-col>
        <b-col xl="8" class="text-center text-sm-left mb-3 mb-sm-0">
          <div class="w-100 action-div">
            <router-link to="/prompt-template/details/0">
              <b-button class="btn-main">
                <div>
                  <font-awesome-icon icon="plus" />
                  <span class="ml-2">CREATE</span>
                </div>
              </b-button>
            </router-link>
          </div>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row class="no-gutters my-3">
          <b-col lg="4">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="input-serach"
                placeholder="Main Keyword"
                @keyup="handleSearch"
                v-model="filter.search"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
          <b-col lg="6" class="text-center text-sm-right"> </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col>
            <b-table
              class="table-list"
              striped
              responsive
              hover
              :items="items"
              :fields="fields"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(id)="data">
                <div class="d-flex justify-content-center">
                  <router-link :to="'/prompt-template/details/' + data.item.id">
                    <b-button variant="link" class="text-warning px-1 py-0">
                      <font-awesome-icon
                        icon="pencil-alt"
                        class="text-primary"
                        title="View"
                      />
                    </b-button>
                  </router-link>
                  <b-button
                    variant="link"
                    class="text-danger px-1 py-0"
                    @click="openModalDelete(data.item)"
                  >
                    <font-awesome-icon icon="trash-alt" title="Delete" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col
            class="form-inline justify-content-center justify-content-sm-between"
          >
            <div v-if="rows > 0" class="my-auto">
              Showing {{ startPage }} to {{ endPage }} of {{ rows }} entires
            </div>
            <div v-else class="my-auto">{{ rows }} entire</div>
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.pageNo"
                :total-rows="rows"
                :per-page="filter.perPage"
                class="m-md-0"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "promptTemplateIndex",
  components: {
    ModalAlert,
    ModalAlertError,
    ModalAlertConfirm
  },
  data() {
    return {
      selected: null,
      options: [{ value: null, text: "สถานะ" }],
      statusList: [],
      modalMessage: "",
      startPage: 1,
      endPage: 10,
      activeItem: "",
      requestDeleted: {
        id: null
      },
      fields: [
        {
          key: "name",
          label: "Name",
          class: "w-100px"
        },
        // {
        //   key: "prompt",
        //   label: "Prompt",
        //   class: "w-100px"
        // },
        {
          key: "id",
          label: "Action"
        }
      ],
      items: [],
      isBusy: false,
      value: false,
      rows: 0,
      filter: {
        search: "",
        pageNo: 1,
        perPage: 50
      },
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" }
      ],
      totalRowMessage: "",
      isDisable: false,
      checkAll: false,
      selectAllCb: false
    };
  },
  created: async function () {
    await this.getList();
    this.getShowingPage(1);
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .get(
          `${this.$baseUrl}/promptTemplate/list?search=${this.filter.search}&page=${this.filter.pageNo}&perpage=${this.filter.perPage}`,
          this.filter
        )
        .then(res => {
          if (res.data.result == 1) {
            this.items = res.data.detail.data;
            this.rows = res.data.detail.count;
            this.isBusy = false;
          }
        });
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
      }
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    getShowingPage(Page) {
      const totalRow = this.rows;
      this.startPage = (Page - 1) * this.filter.perPage + 1;
      if (Page * this.filter.perPage <= totalRow) {
        this.endPage = Page * this.filter.perPage;
      } else {
        this.endPage = totalRow;
      }
    },
    hanndleChangePerpage(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      this.getList();
    },
    openModalDelete(value) {
      this.requestDeleted.id = value.id;
      this.modalMessage = "คุณต้องการลบ " + value.mainKeyword + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(
          `${this.$baseUrl}/promptTemplate/${this.requestDeleted.id}`
        )
        .then(res => {
          if (res.data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalAlert.show();
            this.filter.PageNo = 1;
            this.$refs.modalAlert.hide();
            this.getList();
          } else {
            this.modalMessage = "ไม่สำเร็จ";
            this.$refs.modalAlertError.show();
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.action-div {
  text-align: end;
}
@media (max-width: 767px) {
  .action-div {
    text-align: center;
  }
}
</style>
